import {
  createSharedMediaQueryStore,
  type SharedMediaQueryStore,
} from "@/shared/hooks/createSharedMediaQueryStore";

// OSのprefers-color-schemeをアプリ全体で1本のmatchMediaリスナーに集約する
// 共有シングルトンストア。PostDisplay等、レス数分（モバイル非仮想化リストで
// 最大約1000件）マウントされるコンポーネントが各々matchMedia change リスナーを
// 登録すると、OSテーマ切替のたびに全レスへ change イベントが同時配送され、
// 全レスが同時再レンダリングされる（Issue #50 レビュー指摘）。実際のネイティブ
// リスナーは購読者が1人以上いる間だけ1本しか登録しない。
const systemPrefersDarkStore: SharedMediaQueryStore =
  createSharedMediaQueryStore("(prefers-color-scheme: dark)");

/**
 * OSの`prefers-color-scheme: dark`をアプリ全体で共有する1本の購読として
 * 参照する。何個のコンポーネントから呼ばれても、実際のmatchMedia change
 * リスナーは（購読者が1人以上いる間）常に1本のみ登録される。
 *
 * @param enabled `false`を渡すと購読自体を行わず、シングルトンの購読者
 * カウントにも加わらない。呼び出し側がOS設定を参照しない場合（例:
 * ユーザーがダーク/ライトを明示選択しておりOS追従を使わない場合）に渡すと、
 * OSテーマ切替時の再レンダリング対象からも外れる。既定は`true`。
 */
export function useSystemPrefersDark(enabled: boolean = true): boolean {
  return systemPrefersDarkStore.useMatches(enabled);
}
